import type { Theme } from "@mui/material/styles";
import type { AppSx } from "../types";

export interface AssignedQueriesPanelComponentStyles {
  root: AppSx;
  headerRow: AppSx;
  assignBlock: AppSx;
  pickerInline: AppSx;
  libraryLink: AppSx;
  empty: AppSx;
  list: AppSx;
  item: AppSx;
  itemText: AppSx;
  itemTitle: AppSx;
  itemActions: AppSx;
  pickerOptionLabel: AppSx;
  pickerOptionDescription: AppSx;
}

export function buildAssignedQueriesPanelComponentStyles(
  _theme: Theme
): AssignedQueriesPanelComponentStyles {
  return {
    root: {
      p: 1.5,
      flex: 1,
      overflow: "auto",
      display: "flex",
      flexDirection: "column",
      gap: 1,
    },
    headerRow: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 1,
    },
    assignBlock: {
      display: "flex",
      flexDirection: "column",
      gap: 1,
    },
    pickerInline: {
      width: "100%",
    },
    libraryLink: {
      fontSize: "0.75rem",
      fontWeight: 600,
    },
    empty: {
      py: 3,
      textAlign: "center",
    },
    list: {
      display: "flex",
      flexDirection: "column",
      gap: 0.75,
    },
    item: {
      display: "flex",
      alignItems: "center",
      gap: 0.75,
      px: 1.25,
      py: 1,
      borderRadius: 1.5,
      border: "1px solid",
      borderColor: "divider",
      bgcolor: "background.paper",
    },
    itemText: {
      flex: 1,
      minWidth: 0,
    },
    itemTitle: {
      fontWeight: 600,
    },
    itemActions: {
      display: "flex",
      alignItems: "center",
      gap: 0.25,
      flexShrink: 0,
    },
    pickerOptionLabel: {
      fontWeight: 600,
    },
    pickerOptionDescription: {
      display: "block",
      lineHeight: 1.3,
    },
  };
}
